/**
 * Bit wise & operator that works with number > 32bits
 *
 * @param v1
 * @param v2
 * @returns
 */
export function bitWiseAnd(v1, v2) {
    var hi = 0x80000000;
    var low = 0x7fffffff;
    var hi1 = ~~(v1 / hi);
    var hi2 = ~~(v2 / hi);
    var low1 = v1 & low;
    var low2 = v2 & low;
    var h = hi1 & hi2;
    var l = low1 & low2;
    return h * hi + l;
}
/**
 * Bit wise | operator that works with number > 32bits
 *
 * @param v1
 * @param v2
 * @returns
 */
export function bitWiseOr(v1, v2) {
    var hi = 0x80000000;
    var low = 0x7fffffff;
    var hi1 = ~~(v1 / hi);
    var hi2 = ~~(v2 / hi);
    var low1 = v1 & low;
    var low2 = v2 & low;
    var h = hi1 | hi2;
    var l = low1 | low2;
    return h * hi + l;
}
